export const environment = {
	name: "production",
	production: true,
	apiUrl: "https://api-prod.whatsauto.com.br",
	brokerOfficialWSUrl: "https://broker-ws-official.whatsauto.com.br",
	brokerOfficialQueueConsumerUrl: "",
	CDN_URL: "https://cdn.whatsauto.com.br/files",
	chatFlowAppAddress: "https://chatflow.whatsauto.com.br",
	audioConverterUrl: "https://audioconv.whatsauto.com.br/convert",
	brand: "whatsauto",
	showAutomatedResponseFlag: false,

	facebook: {
		appId: "3081494232012281",
		apiVersion: "v22.0",
		whatsAppConfigId: "2049144535510978",
	},

	// These will be dynamically loaded based on the current hostname
	whatsAutoConfig: {
		appName: "WhatsAuto",
		favicon: "assets/whatsauto/favicon.ico",
		stylePath: "assets/themes/whatsauto.css",
		brand: "whatsauto",
	},
	whatsPartsConfig: {
		appName: "WhatsParts",
		favicon: "assets/whatsparts/favicon.ico",
		stylePath: "assets/themes/whatsparts.css",
		brand: "whatsparts",
	},
};
